import Vue from 'vue';
import { isNil } from 'lodash';
import { isEmptyInputByCurrentLang } from './isInputType';

export function setDefaultInputsValues(state, entries) {
  for (const [key, value] of entries) {
    if (!state.inputs[key] || !isNil(state.inputs[key].value)) continue;
    state.inputs[key].value = value;
  }
}

export function setDefaultInputsDisabled(state, keysOrEntries) {
  const disableCondition = (key) => !state.inputs[key].value || isEmptyInputByCurrentLang(state.inputs[key]);
  const isArrElement = el => Array.isArray(el);
  const isEntries = keysOrEntries.every(isArrElement);

  if (isEntries) {
    for (const [key, value] of keysOrEntries) {
      if (disableCondition(key)) Vue.set(state.inputs[key], 'disabled', value);
    }
  } else if (keysOrEntries.some(isArrElement)) {
    throw new Error('Don\'t use primitives and arrays in one list');
  } else {
    for (const key of keysOrEntries) {
      if (disableCondition(key)) Vue.set(state.inputs[key], 'disabled', true);
    }
  }
}
